import { useEffect } from 'react';

export default function CustHelpChat() {
  useEffect(() => {
    const element = document.getElementById('oit-loader');
    if (element) element.remove();
    const script = document.createElement('script');
    script.id = 'oit-loader';
    script.async = true;
    script.src = `https://radiusbank.widget.custhelp.com/s/oit/latest/common/v0/libs/oit/loader.js`;
    script.setAttribute('data-oit-theme', 'midnight');
    script.setAttribute('data-oit-config-url', '/api/custhelp-config');
    document.body.appendChild(script);
  }, []);
  return (
    <div>
      <inlay-oracle-chat-embedded
        id="chatInlay"
        class="inlay"
        site-url="radiusbank.widget.custhelp.com"
      />
    </div>
  );
}
